export default {
  path: "/culture-operator",
  props: true,
  component: () => import("@/views/LayoutView.vue"),
  children: [
    {
      path: "",
      redirect: "main",
    },
    {
      path: "main",
      props: {
        getDataUrl: "/main",
      },
      component: () => import("@/views/sport-operator/MainPageOperator.vue"),
    },
    {
      path: ":dir/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
    },
    {
      path: ":dir/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
    },
  ],
};
